import { flatten } from 'lodash';
import settings from '../../utils/settings';
import { getCountryBasedLink } from '../../utils/helper';
import { getPlatformBasedUrl } from '../../config/platformBasedUrls/url';
import { RELEASE_NOTES_URL } from '../../config/constants';

export const ACCOUNT_INFORMATION = [
  { label: 'company', name: 'company', url: getPlatformBasedUrl('dashboard.accountInformation.company') },
  {
    label: 'branches',
    name: 'branches',
    url: getPlatformBasedUrl('dashboard.accountInformation.branches'),
    hasChildren: true,
    childrenLabel: [ 'branch-profile', 'createBranch' ]
  },
  {
    label: 'users',
    name: 'users',
    url: getPlatformBasedUrl('dashboard.accountInformation.users'),
    hasChildren: true,
    childrenLabel: [ 'user-profile', 'createUser' ]
  },
  {
    label: 'area-coverage',
    name: 'area_coverage',
    url: getPlatformBasedUrl('dashboard.accountInformation.areaCoverage'),
    isHardload: true
  },
  {
    label: 'lead-program',
    name: 'lead_program',
    url: getPlatformBasedUrl('dashboard.accountInformation.leadProgram'),
    isHardload: true
  },
  {
    label: 'ein-program',
    name: 'ein_program',
    url: getPlatformBasedUrl('dashboard.accountInformation.einProgram')
  },
  {
    label: 'ac-module-admin',
    name: 'ac_module_admin',
    url: `${window.location.origin}/account/acm_admin`,
    isExternalLink: true
  },
  {
    label: 'my-training',
    name: 'training_dashboard',
    url: `my-training`,
    isExternalLink: false
  },
  {
    label: 'authorized-subcontractor',
    name: 'authorized_subcontractor',
    url: 'authorized-subcontractor',
    isExternalLink: false
  },
  {
    label: 'request_system_access',
    name: 'request_system_access',
    url: `company#request_system_access`,
    isExternalLink: false
  }
];

export const SERVICES = [
  {
    name: 'enphase_store',
    label: 'enphase_store',
    url: getCountryBasedLink('enphaseStore'),
    isExternalLink: true
  },
  {
    label: 'product-warranty-extension',
    name: 'product_warranty_extension',
    url: getCountryBasedLink('productWarrantyExtension'),
    isExternalLink: true
  },
  {
    label: 'generator-tokens',
    name: 'generator_tokens',
    url: getPlatformBasedUrl('dashboard.services.generatorTokens'),
  },
  {
    label: 'data-plan-extension',
    name: 'data_plan_extension',
    url: getPlatformBasedUrl('dashboard.services.dataPlanExtension'),
    },
  { label: 'labor-protection', name: 'lpp', url: getPlatformBasedUrl('dashboard.services.lpp') },
  {
    label: 'permitting-assistance',
    name: 'permit_assistance',
    url: getPlatformBasedUrl('dashboard.services.permit'),
    hasChildren: true,
    childrenLabel: [ 'edit-permit', 'new' ]
  },
  {
    label: 'rma-dashboard',
    name: 'rma_dashboard',
    url: getPlatformBasedUrl('dashboard.services.rma'),
  },
  {
    label: 'sgip-incentive',
    name: 'incentive_programs',
    url: getPlatformBasedUrl('dashboard.services.sgip'),
    isComingSoon: false
  },
  {
    label: 'ein-merchandise',
    name: 'ein_merchandise',
    url: 'http://businesscenter.enphase.com',
    isExternalLink: true
  },
  {
    label: 'design-tool',
    name: 'design_tool',
    url: getPlatformBasedUrl('dashboard.services.designTool')
  },
  {
    label: 'design-review',
    name: 'design_review_service',
    url: getPlatformBasedUrl('drs.dashboard'),
    isExternalLink: true,
    hasChildren: true,
    childrenLabel: [ 'edit-drs', 'new', 'application-status' ]
  },
  {
    label: 'bom-calculator',
    name: 'bom',
    url: getPlatformBasedUrl('dashboard.services.bom')
  },
  {
    label: 'evse-incentives-tool',
    name: 'evse_incentives_tool',
    url: 'https://enphase.com/ev-chargers/incentives',
    isExternalLink: true
  }
  //{ label: 'financing', name: 'Financing', url: '', isComingSoon: true }
];

export const BENEFITS = [
  { label: 'ein-program', name: 'ein_program', url: 'ein-program' },
  {
    name: 'training',
    url: 'https://enphase.com/en-us/training-ensemble?utm_source=enlighten-manager-home&utm_medium=referral',
    isExternalLink: true
  },
  { name: 'collaterals', url: '', isComingSoon: true }
];

export const LEAD_MANAGEMENT = [
  {
    label: 'leads',
    name: 'my_leads',
    url: ':company_id/leads',
    hasChildren: true,
    childrenLabel: [ 'lead-details' ]
  },
  { label: 'lead-details', name: 'lead_details', url: ':company_id/leads/:lead_id', hideBreadcrumb: true }
];

export const DATA_PRIVACY = [
  { label: 'api-access', name: 'api_access', url: getPlatformBasedUrl('dashboard.dataPrivacy.apiAccess') },
  {
    label: 'third-party-reporting',
    name: 'third_party',
    url: getPlatformBasedUrl('dashboard.dataPrivacy.thirdPartyReporting')
  },
  { label: 'profiles', name: 'profiles', url: getPlatformBasedUrl('dashboard.dataPrivacy.profiles') }
];

export const SUPPORT = [
  {
    name: 'enphase_community',
    label: 'enphase_community',
    url: getCountryBasedLink('support'),
    isExternalLink: true
  },
  {
    name: 'whats_new',
    label: 'whats_new',
    url: RELEASE_NOTES_URL,
    isExternalLink: true
  },
];

export const BRANCHES = [
  { label: 'createBranch', name: 'createBranch', url: 'branches/create' },
  { label: 'branch-profile', name: 'branch_profile', url: 'branches/:company_id', isHardload: true }
];

export const PERMIT_ASSISTANCE = [
  {
    label: 'edit-permit',
    name: 'edit',
    url: ':source_id/permitting-assistance/:id'
  },
  { label: 'new', name: 'new', url: ':source_id/permitting-assistance/new' }
];

export const SGIP_INCENTIVE = [ { label: 'applications', name: 'applications', url: 'sgip-incentive/applications' } ];

export const DESIGN_REVIEW = [
  {
    label: 'edit-drs',
    name: 'edit',
    url: ':site_id/design-review/:drs_id',
    hasGoBack: true
  },
  { label: 'drs-new', name: 'new', url: ':site_id/design-review/new', hasGoBack: true },
  {
    label: 'application-status',
    name: 'application_status',
    url: ':site_id/design-review/:drs_id/application-status',
    hasGoBack: true
  }
];

export const COMMERCIAL = [
  {
    label: 'commercial',
    name: 'Commercial',
    url: 'commercial'
  }
];

export const BOM = [
  {
    label: 'bom',
    name: 'bom',
    url: 'bom'
  }
];

export const MODEM_REPLACEMENT = [
  {
    label: 'modem-replacement',
    name: 'modem_replacement',
    url: 'modem-replacement'
  }
];
export const RMA_DASHBOARD = [
  {
    label: 'rma-dashboard',
    name: 'rma_dashboard',
    url: 'rma-dashboard'
  }
];

export const GENERATOR_TOKENS = [
  {
    label: 'generator-tokens',
    name: 'generator_tokens',
    url: 'generator-tokens'
  }
];

export const CELL_MODEM_DATA_PLAN_EXTENSION = [
  {
    label: 'data-plan-extension',
    name: 'data_plan_extension',
    url: 'data-plan-extension'
  }
];

export const PRONTO = [
  { label: 'pronto', name: 'pronto_signup', url: 'pronto' }
];

export const USERS = [
  { label: 'createUser', name: 'createUser', url: 'users/create' },
  { label: 'user-profile', name: 'user_profile', url: 'users/:user_id' }
];

export const EINDASHBOARD = [ { label: 'ein-dashboard', name: 'einDashboard', url: 'ein-dashboard' } ];

export const ADMIN_NEW = [ { label: 'admin-new', name: 'adminNew', url: 'admin-new', hideBreadcrumb: true } ];

export const ADMIN = [
  {
    label: 'platform-discounts',
    name: 'platform_discounts',
    url: '/manager/admin/platform-discounts'
  },
  {
    label: 'ein',
    name: 'einAdmin',
    url: '/manager/admin/ein'
  }
];

export const ACCOUNT_DETAILS = [
  {
    label: 'account-details',
    name: 'account_details',
    url: 'account-details',
    hasGoBack: true,
    googleAnalyticsName: 'Account Details'
  },
  {
    label: 'preferences',
    name: 'preferences',
    url: 'preferences',
    hasGoBack: false,
    googleAnalyticsName: 'Preferences'
  },
  {
    label: 'change-password',
    name: 'change_password',
    url: 'account-details',
    hasGoBack: true,
    googleAnalyticsName: 'Change Password'
  }
];

export const SYSTEMS = [ { label: 'lpp', name: 'lpp', url: 'labor-protection' } ];

export const BASEPATH = [
  {
    label: 'account',
    name: 'account',
    url: '/manager/account',
    hasChildren: true,
    isBasePath: true,
    childrenLabel: [
      'company',
      'branches',
      'users',
      'area-coverage',
      'ein-program',
      'lead-program',
      'api-access',
      'third-party-reporting',
      'profiles'
    ]
  },
  {
    label: 'dashboard',
    name: 'dashboard',
    url: '/manager/dashboard',
    hasChildren: true,
    isBasePath: true,
    childrenLabel: [
      'company',
      'branches',
      'users',
      'area-coverage',
      'ein-program',
      'lead-program',
      'api-access',
      'third-party-reporting',
      'profiles'
    ]
  },
  {
    label: 'systems',
    name: 'systems',
    url: settings.enlightenMenuUrl('systems'),
    hasChildren: true,
    isBasePath: true,
    isHardload: true,
    childrenLabel: [ 'labor-protection' ]
  },
  {
    label: 'admin',
    name: 'admin',
    url: '/manager/admin',
    hasChildren: true,
    isBasePath: true,
    childrenLabel: [ 'platform-discounts' ]
  },
  ...ACCOUNT_DETAILS
];

export const breadCrumbList = flatten([
  BASEPATH,
  ACCOUNT_INFORMATION,
  SERVICES,
  BENEFITS,
  DATA_PRIVACY,
  LEAD_MANAGEMENT,
  BRANCHES,
  USERS,
  ADMIN,
  PERMIT_ASSISTANCE,
  SYSTEMS,
  SGIP_INCENTIVE,
  EINDASHBOARD,
  ADMIN_NEW,
  COMMERCIAL,
  DESIGN_REVIEW,
  BOM,
  MODEM_REPLACEMENT,
  RMA_DASHBOARD,
  GENERATOR_TOKENS,
  PRONTO,
  CELL_MODEM_DATA_PLAN_EXTENSION
]);

export const accountLists = [
  {
    key: 'account_information',
    title: 'account_information',
    list: ACCOUNT_INFORMATION
  },
  {
    key: 'services',
    title: 'services',
    list: SERVICES
  },
  {
    key: 'data_privacy',
    title: 'data_privacy',
    list: DATA_PRIVACY
  }
];

export const benefitsList = {
  key: 'benefits',
  title: 'benefits',
  list: BENEFITS
};

export const semanticValues = [
  {
    label: 'company_id',
    key: 'companyId'
  },
  {
    label: 'lead_id',
    key: 'leadId'
  },
  {
    label: 'source_id',
    key: 'sourceId'
  },
  {
    label: 'id',
    key: 'id'
  }
];

export const onlyForUS = [
  'ein-program',
  'area-coverage',
  'labor-protection',
  'permitting-assistance',
  'sgip-incentive',
  'financing',
  'design-tool',
  'design-review',
  'bom-calculator'
];

export const onlyForAU = [
  // Australia
  'product-warranty-extension',
  'area-coverage',
  'ein-program',
  'design-review'
];

export const onlyForNZ = ['product-warranty-extension', 'area-coverage', 'ein-program', 'design-review'];

export const onlyForNC = ['product-warranty-extension', 'area-coverage', 'ein-program'];

export const onlyForDE = ['area-coverage', 'ein-program', 'design-review']; // Germany

export const onlyForNL = ['area-coverage', 'ein-program','design-review'];

export const onlyForBE = ['area-coverage', 'ein-program', 'design-review']; // Belgium

export const onlyForMX = [
  //Mexico
  'area-coverage',
  'ein-program',
  'product-warranty-extension',
  'design-review'
];

export const onlyForBR = ['area-coverage', 'ein-program'];

export const onlyForIN = ['product-warranty-extension', 'area-coverage', 'ein-program'];

export const onlyForFr = ['area-coverage', 'ein-program','design-review'];

export const onlyForEs = [ 'area-coverage', 'ein-program','design-review'];

export const inactiveStatesInUS = [ 'NY', 'OR' ];
export const onlyForAT = ['design-review']; // Austria
export const onlyForCA = ['design-review']; // Canada
export const onlyForCH = ['design-review']; // Switzerland
export const onlyForPT = ['design-review']; // Portugal
export const onlyForDK = ['design-review']; // Denmark
export const onlyForSE = ['design-review']; // Sweden
export const onlyForGR = ['design-review']; // Greece
export const onlyForZA = ['design-review']; // South Africa
export const selfInstallerLabels = [ 'enphase_store', 'design-review', 'profiles', 'enphase_community', 'whats_new', 'evse-incentives-tool' ];
export const viewOnlyDisabledLabels = ['sgip-incentive', 'permitting-assistance', 'labor-protection', 'design-tool'];
